import { axiosInstanceForTenantAPI } from '../assets/utils/axiosInstance';
import { SuggestionDataItem, User } from '../interfaces/SuggestionUser';

export const fetchUserList = async (
  query: string,
  callback: (data: SuggestionDataItem[]) => void,
) => {
  if (!query) return;
  const response = await axiosInstanceForTenantAPI().get('/users', {
    params: { search: query },
  });
  const listOfUsersArray: User[] = response.data.account_settings_user_list;

  // Filter users based on is_removed
  const filteredArray = listOfUsersArray.filter((user) => !user.is_removed);

  const mentionUsers: SuggestionDataItem[] = filteredArray.map((user) => {
    return {
      id: user.id,
      display: user.full_name,
    };
  });

  callback(mentionUsers);
};

export const stringToColor = (string: string) => {
  let hash = 0;
  let i;

  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
   

  return color;
};
